<template>
  <div class="container mx-auto py-8 mt-12">
    <div class="flex flex-wrap -mx-4">
      <div class="w-full md:w-1/2 px-4">
        <div class="bg-gray-100 rounded-lg shadow-xl p-6 mb-8">
          <div class="flex flex-col md:flex-row">
            <div class="md:order-2 md:ml-4">
              <h4 class="text-lg font-semibold mb-4">Parkea APP</h4>
              <p class="text-gray-700">
                This project is made with the Ruby on Rails framework using a monolithic architecture.
                It simulates the management and administration of a parking lot company, with an architecture design based on layers.
                The front end is developed using HTML and CSS, with the addition of the tailwind.css library.
              </p>
              <h1 class="text-lg font-semibold mt-6">Github Links</h1>
              <ul class="list-disc list-inside text-gray-700">
                <li>
                  <a href="https://github.com/juanfrg201/ParKea-App.git" class="text-gray-700">
                    https://github.com/juanfrg201/ParKea-App.git
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full md:w-1/2 px-4">
        <div class="bg-gray-100 rounded-lg shadow-xl p-6 mb-8">
          <div class="flex flex-col md:flex-row">
            <div class="md:order-2 md:ml-4">
              <h4 class="text-lg font-semibold mb-4">Movie System</h4>
              <p class="text-gray-700">
                This project is created with an Object Oriented architecture in which the idea is basically to separate the backen
                with the client side, the structure of the project is defined as follows,from the back is used ruby on rails
                for database management and in the front is used the framewrok vue.js to display requests.
              </p>
              <h1 class="text-lg font-semibold mt-6">Github Links</h1>
              <ul class="list-disc list-inside text-gray-700">
                <p class="text-lg font-semibold mt-3">BackEnd</p>
                <li>
                  <a href="https://github.com/juanfrg201/movie-back" class="text-gray-700">
                    https://github.com/juanfrg201/movie-back
                  </a>
                </li>
                <p class="text-lg font-semibold mt-3">FrontEnd</p>
                <li>
                  <a href="https://github.com/juanfrg201/movie-view" class="text-gray-700">
                    https://github.com/juanfrg201/movie-view
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full md:w-1/2 px-4">
        <div class="bg-gray-100 rounded-lg shadow-xl p-6 mb-8">
          <div class="flex flex-col md:flex-row">
            <div class="md:order-2 md:ml-4">
              <h4 class="text-lg font-semibold mb-4">StackCellPhone</h4>
              <p class="text-gray-700">
                This project has a layered design architecture in a monolithic way in which at its base is
                the management of a cell phone company whose function is to register cell phones and see a blog of comments
                by other users, this created the backend with ruby on rails and fornt end is used Html, Css with tailwind libraries.
              </p>
              <h1 class="text-lg font-semibold mt-6">Github Links</h1>
              <ul class="list-disc list-inside text-gray-700">
                <li>
                  <a href="https://github.com/juanfrg2001/StackCellPhone" class="text-gray-700">
                    https://github.com/juanfrg2001/StackCellPhone
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full md:w-1/2 px-4">
        <div class="bg-gray-100 rounded-lg shadow-xl p-6 mb-8">
          <div class="flex flex-col md:flex-row">
            <div class="md:order-2 md:ml-4">
              <h4 class="text-lg font-semibold mb-4">PetClinical Center</h4>
              <p class="text-gray-700">
                This project has a monolithic architecture in which is based 
                on the use of the pyhton flask framwork handling the front with
                html and css, is based on a management and administration of an
                animal clinic.
              </p>
              <h1 class="text-lg font-semibold mt-6">Github Links</h1>
              <ul class="list-disc list-inside text-gray-700">
                <li>
                  <a href="https://github.com/juanfrg2001/pet-clinical.center" class="text-gray-700">
                    https://github.com/juanfrg2001/pet-clinical.center
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full md:w-1/2 px-4">
        <div class="bg-gray-100 rounded-lg shadow-xl p-6 mb-8">
          <div class="flex flex-col md:flex-row">
            <div class="md:order-2 md:ml-4">
              <h4 class="text-lg font-semibold mb-4">Sample APP</h4>
              <p class="text-gray-700">
                An application with crud functions using Ruby on rails as main framewrok , 
                and database in postgresql using HTMl,
                 CSS and js , this project was made in tutorail of a RoR learning book.
              </p>
              <h1 class="text-lg font-semibold mt-6">Github Links</h1>
              <ul class="list-disc list-inside text-gray-700">
                <li>
                  <a href="https://github.com/juanfrg2001/Sample-appVersionCompleta.git" class="text-gray-700">
                    https://github.com/juanfrg2001/Sample-appVersionCompleta.git
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full md:w-1/2 px-4">
        <div class="bg-gray-100 rounded-lg shadow-xl p-6 mb-8">
          <div class="flex flex-col md:flex-row">
            <div class="md:order-2 md:ml-4">
              <h4 class="text-lg font-semibold mb-4">Calory Weight app</h4>
              <p class="text-gray-700">
                An application made with Ruby on rails in order 
                to have a control of calories and weight of people, 
                has use of gems for data visualization, with a use of
                 a local sqlite database and in production with postgresql,
                  heroku was handled for the deployment of the application.
              </p>
              <h1 class="text-lg font-semibold mt-6">Github Links</h1>
              <ul class="list-disc list-inside text-gray-700">
                <li>
                  <a href="https://github.com/juanfrg2001/proyecto3-correccion-final.git" class="text-gray-700">
                    https://github.com/juanfrg2001/proyecto3-correccion-final.git
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'ModalCart',
	}
</script>